import React from "react";
import VStack from "../../ui_atoms/VStack";
import { Text } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import { BubbleTalk } from "../../components/BubbleTalk";
import { TitleMediumText } from "../../components/FormattedText";
import Avatar1Svg from "../../assets/images/avatar_1.svg";
import ScreenCard from "../../screens/ScreenCard";
import { useTheme } from "../../hooks/use-theme";

function BubbleTalkStoryComponent() {
    const { colors } = useTheme();
    const bubbleTalkProps = {
        personImageComponent: <Avatar1Svg />,
        personStyle: { borderWidth: 4, borderColor: colors.accentLighter },
    };
    return (
        <ScreenCard>
            <VStack
                gap={0.5}
                h={1}
                style={{
                    alignSelf: "stretch",
                }}
            >
                <BubbleTalk {...bubbleTalkProps} position="top-left">
                    <TitleMediumText>
                        Voilà ! Le contrat est prêt pour être lu et signé.
                    </TitleMediumText>
                </BubbleTalk>
                <BubbleTalk {...bubbleTalkProps} position="top-center">
                    <TitleMediumText>
                        Voilà ! Le contrat est prêt pour être lu et signé.
                    </TitleMediumText>
                </BubbleTalk>
                <BubbleTalk {...bubbleTalkProps} position="top-right">
                    <TitleMediumText>
                        Voilà ! Le contrat est prêt pour être lu et signé.
                    </TitleMediumText>
                </BubbleTalk>
                <BubbleTalk {...bubbleTalkProps} position="center-left">
                    <TitleMediumText>
                        Voilà ! Le contrat est prêt pour être lu et signé.
                    </TitleMediumText>
                </BubbleTalk>
                <BubbleTalk {...bubbleTalkProps} position="center-right">
                    <TitleMediumText>
                        Voilà ! Le contrat est prêt pour être lu et signé.
                    </TitleMediumText>
                </BubbleTalk>
                <BubbleTalk {...bubbleTalkProps} position="bottom-left">
                    <TitleMediumText>
                        Voilà ! Le contrat est prêt pour être lu et signé.
                    </TitleMediumText>
                </BubbleTalk>
                <BubbleTalk {...bubbleTalkProps} position="bottom-center">
                    <TitleMediumText>
                        Voilà ! Le contrat est prêt pour être lu et signé.
                    </TitleMediumText>
                </BubbleTalk>
                <BubbleTalk {...bubbleTalkProps} position="bottom-right">
                    <TitleMediumText>
                        Voilà ! Le contrat est prêt pour être lu et signé.
                    </TitleMediumText>
                </BubbleTalk>
            </VStack>
        </ScreenCard>
    );
}

const meta = {
    title: "Atom/BubbleTalk",
    component: BubbleTalkStoryComponent,
    argTypes: {},
} satisfies Meta<typeof BubbleTalkStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
